import { render } from "./ErrorComponent.vue?vue&type=template&id=568732b2"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__